<template>
    <div class="subtitle-translated-localization-cue text-primary" :class="{ 'bg-info': ! locked }">
        <div class="row" :id="'diff-wrapper'+number">
            <div class="col-xs-1">
                #{{ number }}
                <i class="fa lock"
                   :class="{ 'fa-lock': lockedState, 'fa-unlock': ! lockedState }"
                   v-if="locked"
                   @click="toggleLock"
                ></i>
            </div>
            <div class="col-xs-3">
                <p dir="auto" style="padding-bottom: 5px; line-height: 2em;" v-html="masterLines"
                   :id="'original'+number"></p>
                <p dir="auto" style="padding-bottom: 5px; line-height: 2em;" class="hide" v-html="localizedLines"
                   :id="'changed'+number"></p>
            </div>

            <div class="col-xs-3">
                <div dir="auto" style="padding-bottom: 5px; line-height: 2em;" :class="'diff'+number"></div>
            </div>

            <div class="col-xs-5">
                <subtitle-cue-textarea
                        :lines="translatedLines"
                        :name="'edits['+number+']'"
                        :key="number"
                        :required="'required'"
                        :disabled="lockedState">
                </subtitle-cue-textarea>
            </div>
        </div>
    </div>
</template>

<script>
    require('../../../vendor/jquery/plugins/diff_match_patch/javascript/diff_match_patch');
    require('../../../vendor/jquery/plugins/preetyTextDiff/jquery.pretty-text-diff.min');

    export default {
        props: [
            'number',
            'masterLines',
            'localizedLines',
            'translatedLines',
            'locked'
        ],

        mounted() {
            this.lockedState = this.locked;
            $("#diff-wrapper" + this.number).prettyTextDiff({
                originalContent: $('#original' + this.number).html(),
                changedContent: $('#changed' + this.number).html(),
                diffContainer: ".diff" + this.number,
                debug: false,
            });
        },

        ready() {
        },

        data: function () {
            return {
                lockedState: false,
            };
        },

        methods: {
            toggleLock: function () {
                this.lockedState = !this.lockedState;
            }
        }
    }
</script>

<style>
    .subtitle-translated-localization-cue {

    .lock {
        cursor: pointer;
    }

    }
</style>
